import { UserRole } from '@depanneo/types'
import { requiredRoles } from '@/shared/utils/require-roles'
import { createFileRoute } from '@tanstack/react-router'
import { getSites } from '@/api/sites-api'
import { siteKeys } from '@/hooks/sites/query-keys'

export const Route = createFileRoute('/_authenticated/org/$orgId/sites/')({
  beforeLoad: () => {
    requiredRoles([UserRole.ADMIN, UserRole.FACILITY_MANAGER, UserRole.VIEWER])
  },
  loader: async ({ params: { orgId }, context: { queryClient } }) => {
    return await queryClient.ensureQueryData({
      queryKey: siteKeys.list(orgId),
      queryFn: () => getSites(),
    })
  },
})
